<template>
  <div class="applied-potential-page">
    <ul
      v-infinite-scroll="getPotentialDate"
      class="applied-potential-container"
      :infinite-scroll-disabled="disabledLoadDate"
    >
      <div v-if="isPc && companyId && !wxUserHasBindRewards" class="get-rewards">
        <el-button class="get-rewards-btn" @click="handleGetQrCode">{{ $t('personal.referrals.rewards.label.getRewards') }}</el-button>
      </div>
      <li v-for="(item, index) in appliedList" :key="index" class="page-item">
        <PotentialInfo :isPc="isPc" :potentialData="item" :isAppliedList="true"/>
      </li>
      <li v-if="appliedList.length < 1" class="tips">
        <p>{{ $t('personal.referrals.leads.message.appliedNoData') }}</p>
      </li>
    </ul>
    <WeChatBindQrCodeDialog
      :show.sync="showWeChatBindQrCodeDialog"
      :companyId="companyId"
      :isPc="isPc"
    ></WeChatBindQrCodeDialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PotentialInfo from './components/potentialInfo.vue'
import { deviceType } from '@/utils/common'
import WeChatBindQrCodeDialog from '../wechatBindQrCodeDialog.vue'

export default {
  props: {

  },
  components: {
    PotentialInfo,
    WeChatBindQrCodeDialog
  },
  data () {
    return {
      appliedList: [],
      disabledLoadDate: false,
      pageInfo: {
        pageSize: 20,
        currentPage: 1,
        total: 1
      },
      showWeChatBindQrCodeDialog: false
    }
  },
  created () {

  },
  computed: {
    ...mapGetters('account', ['wxUserHasBindRewards']),
    isPc () {
      return deviceType.isPc
    },
    companyId () {
      return this.$route.query.company_id
    }
  },
  methods: {
    ...mapActions('personal', ['getMyAppliedPotentialCandidate']),
    handleGetQrCode () {
      if (!this.companyId) {
        return
      }
      this.showWeChatBindQrCodeDialog = true
    },
    async initData () {

    },
    async getPotentialDate () {
      this.$eventBus.$emit('showLoading', true)
      this.disabledLoadDate = true
      try {
        const params = {
          page: this.pageInfo.currentPage,
          page_size: this.pageInfo.pageSize
        }
        if (!this.isPc) {
          params.company_id = this.$route.query.company_id
        }
        const resp = await this.getMyAppliedPotentialCandidate(params)
        if (resp) {
          this.pageInfo.total = resp.total_pages
          this.pageInfo.currentPage += 1
          if (this.pageInfo.total > 0 && this.pageInfo.currentPage < this.pageInfo.total) {
            this.disabledLoadDate = false
          }
          this.appliedList = this.appliedList.concat(resp.results)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.applied-potential-page {
  .applied-potential-container {
    padding-bottom: 20px;

    .get-rewards {
      margin-bottom: 15px;
      text-align: right;
      .get-rewards-btn {
        height: 30px;
        padding: 0 28px;
        border-radius: 999px;
        border-color: var(--custom-color);
        color: #fff;
        background-color: var(--custom-color);
      }
    }

    .page-item {
      margin: 24px 0;
    }

    .tips {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
